


















































import { FiltrosConsultor, HomeService } from "@/services/home.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { cpf, dateTime, dateTimeSeconds } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

@Component({
  components: { DataTable, Tooltip },
  filters: { dateTimeSeconds, cpf, dateTime },
})
export default class Home extends mixins(GlobalMixin) {
  loading = false;
  selectRow = true;
  home: Promise<any[]> | null = null;

  filtro: FiltrosConsultor = {
    txtPesquisa: "",
    offset: 0,
    limit: 50,
    order: "",
  };

  headers = [
    { value: "idConsultor", text: "ID" },
    { value: "nome", text: "Nome" },
    { value: "cpf", text: "CPF" },
    { value: "email", text: "Email" },
    { value: "dataCadastro", text: "Data Cadastro" },
    { value: "dataUltimoLogin", text: "Último Acesso" },
    { value: "ativo", text: "Ativo" },
  ];

  mounted() {
    this.filtro.txtPesquisa = "";
  }

  async fetchHome(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }

    this.home = HomeService.ListaConsultor(this.filtro);
  }

  selecionadoConsultor(item: any) {
    if (item) {
      this.$router.push({
        name: "consultores",
        params: { idConsultor: item.idConsultor },
      });
    }
  }
}
